export const ROUTE_PATHS = {
  home: "/",
  category: "/category/:slug",
  product: "/product/:id",
  search: "/search",
  cart: "/cart",
  checkout: "/checkout",
  orderTime: "/order-time",
  gift: "/gift",
  addresses: "/addresses",
  addressNew: "/addresses/new",
  account: "/account",
  orders: "/orders",
  orderDetails: "/orders/:id",
  branches: "/branches",
  branchDetails: "/branches/:branchId",
  login: "/login",
  register: "/register",
  adminRoot: "/admin",
  adminProducts: "/admin/products",
  adminProductNew: "/admin/products/new",
  adminOrders: "/admin/orders",
  adminOrderDetails: "/admin/orders/:id",
  adminCategories: "/admin/categories",
  adminVouchers: "/admin/vouchers",
};

export const toOrderDetailsPath = (id) => `/orders/${id}`;
export const toAdminOrderDetailsPath = (id) => `/admin/orders/${id}`;






